import styled, { css } from "styled-components";
import { SectionContainer } from "screens/Homepage/styles";
import { Avatar, Typography } from "@beamcloud/design-system";
import { typography } from "screens/Homepage/components/typography";
import LouisMorganer from "assets/homepage/landing/testimonials/louis.jpeg";
import Frankie from "assets/homepage/landing/testimonials/frankie.jpeg";
import InvestorSection from "screens/Homepage/components/InvestorsCarousel";

const TestimonialSection: React.FC = () => {
  return (
    <SectionContainer>
      <QuotesContainer>
        <QuoteWrapper>
          <Quote tag="p" color="gray12">
            Beam is powering hands-down the best developer experience to run models on GPUs easily at scale.
            Best decision on the infra side for us this year so far.
          </Quote>
          <Info>
            <Avatar size={48} bgColor="gray9" imageSrc={LouisMorganer} />
            <NameWrapper>
              <Typography tag="span" variant="textBasePlus" color="gray12">
                Louis Morgner
              </Typography>
              <JobTitle>Co-founder, AI lead @ Jamie</JobTitle>
            </NameWrapper>
          </Info>
        </QuoteWrapper>
        <QuoteWrapper>
          <Quote tag="p" color="gray12">
            Frase is running language models exclusively on Beam and it was surprisingly easy to migrate, less
            maintenance, and is saving us money.
          </Quote>
          <Info>
            <Avatar size={48} bgColor="gray9" imageSrc={Frankie} />
            <NameWrapper>
              <Typography tag="span" variant="textBasePlus" color="gray12">
                Frankie L.
              </Typography>
              <JobTitle>CTO at Frase</JobTitle>
            </NameWrapper>
          </Info>
        </QuoteWrapper>
      </QuotesContainer>
      <InvestorSection />
    </SectionContainer>
  );
};

export default TestimonialSection;

const QuotesContainer = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 32px;
    max-width: 1152px;

    @media (max-width: ${theme.breakpoints.lg}px) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;

const QuoteWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: 20px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: 8px;
    border: 1px solid ${theme.colors.gray6};
    background: ${theme.colors.gray3};
  `}
`;

const Quote = styled(Typography).attrs({
  tag: "p",
  color: "gray12"
})`
  && {
    ${typography.title24};
    line-height: 144%;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 12px;
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
`;

const JobTitle = styled(Typography).attrs({
  tag: "span",
  color: "gray11"
})`
  && {
    ${typography.textBaseLight};
  }
`;
